import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentStoreCreditPage } from 'src/app/modals/checkout-payment-store-credit/checkout-payment-store-credit';

const routes: Routes = [
    {
        path: '',
        component: CheckoutPaymentStoreCreditPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [CheckoutPaymentStoreCreditPage]
})
export class CheckoutPaymentStoreCreditPageModule { }
